app.component("patientHeader", {
	templateUrl: "app/src/js/components/patientHeader/patientHeader.html",
	controller: "patientHeaderController",
	bindings: {
		onEditClick: '&',
		showButton: '<',
		reload: '&',
	},
});
app.controller("patientHeaderController", [
	"$scope",
	"$location",
	"CurrentPatient",
	"PatientAPI",
	"Session",
	"ReferralsAPI",
	"CurrentReferral",
	"$window",
	"$state",
	"AllergyAPI",
	"ShareData",
	"BillingAPI",
	"$modal",
	"$mdDialog",
	"$filter",
	"AppointmentAPI",
	"$stateParams",
	"countryConfig",
	"$timeout",
	"CLINIC_LETTER_282",
	"EORDERS_1054",
	"TyroAPI",
	"$rootScope",
	"PatientVerificationLiveUpdateService",
	"PatientRecordLiveUpdateService",
	"PATIENT_FORM_1258",
	"PatientFormsAPI",
	"SettingsDialog",
	"PUSH_EVENTS",
	function ($scope,
		$location,
		CurrentPatient,
		PatientAPI,
		Session,
		ReferralsAPI,
		CurrentReferral,
		$window,
		$state,
		AllergyAPI,
		ShareData,
		BillingAPI,
		$modal,
		$mdDialog,
		$filter,
		AppointmentAPI,
		$stateParams,
		countryConfig,
		$timeout,
		CLINIC_LETTER_282,
		EORDERS_1054,
		TyroAPI,
		$rootScope,
		PatientVerificationLiveUpdateService,
		PatientRecordLiveUpdateService,
		PATIENT_FORM_1258,
		PatientFormsAPI,
		SettingsDialog,
		PUSH_EVENTS) {
		$scope.PA = PatientAPI;
		$scope.CP = CurrentPatient;
		$scope.RA = ReferralsAPI;
		$scope.CR = CurrentReferral;
		$scope.AllergyAPI = AllergyAPI;
		$scope.SD = ShareData;
		$scope.BillingAPI = BillingAPI;
		$scope.AppointmentAPI = AppointmentAPI;
		$scope.TyroAPI = TyroAPI;
		$scope.countryConfig = countryConfig;
		$scope.showConsultTimer = true;
		$scope.clinicLetterEnabled = CLINIC_LETTER_282;

		// Worked out again whenever the user's permissions are re-read (practice switch, a role change
		// pushed from the server, coming back to the tab), so the header never offers stale actions.
		function applyPermissions() {
			// Only someone who can send the referral may start one: technicians could fill in the examination
			// but never finish it.
			$scope.canReferPatient = Session.hasPermission("CLINICAL_EXAMINATION_WRITE")
				&& Session.hasPermission("CLINICAL_REFERRAL_UPDATE");
			// The screen has always kept front-desk-only staff out of eOrders, though the server lets them in.
			const onlyPracticeAdmin = Session.user.roles.length === 1 && Session.user.roles[0] === "PRACTICE_ADMIN";
			$scope.canPrescribeElectronically = Session.hasPermission("CLINICAL_MEDICATION_ELECTRONIC_PRESCRIBE")
				&& !onlyPracticeAdmin;
			// The "record visit" menu is worth opening if the user may start anything on it.
			$scope.canRecordVisit = Session.hasPermission("SURGERY_AGREEMENT_MANAGE")
				|| Session.hasPermission("CLINICAL_MEDICAL_CERTIFICATE_ISSUE")
				|| Session.canStartWorkup()
				|| Session.hasPermission("SURGERY_OPERATION_NOTE_WRITE")
				|| Session.hasPermission("CLINICAL_INJECTION_NOTE_WRITE");
			$scope.transcriptionEnabled = !!$scope.CP.patient.id && countryConfig.transcriptionFeatureEnabled
				&& Session.hasPermission("AI_TRANSCRIPTION_USE");
		}
		$scope.$watch(function () {
			return Session.permissions;
		}, applyPermissions);
		applyPermissions();
		$scope.CALENDAR_ENABLE = Session.practice.practiceFeatures && Session.practice.practiceFeatures.calendarFeature;
		// eOrders goes to NZ labs only (MedLab, Pathlab, Awanui), so it is NZ-only like the tips that advertise it.
		$scope.EORDERS_ENABLE = EORDERS_1054 && countryConfig.countryCode === "NZ";

		// Two gates, same as the AI agent: PATIENT_FORM_1258 is the release toggle for the
		// feature as a whole, patientCustomFormsFeature is the per-practice entitlement. Every
		// endpoint under /api/patient-forms/custom-forms enforces the practice flag server-side
		// and 500s without it, so a practice that does not have it must not be shown the menu.
		$scope.PATIENT_FORM_ENABLE = PATIENT_FORM_1258
			&& !!(Session.practice.practiceFeatures && Session.practice.practiceFeatures.patientCustomFormsFeature);

		$scope.eOrdersStatus = {
			isMedlabDisabled: true,
			isPathlabDisabled: true,
			isAwanuiDisabled: true
		}
		$scope.$watch(
			"CP.patient.nhi",
			function (newValue, oldValue) {
				// if (newValue == false && oldValue == true) {
					if ($scope.CP.patient.nhi && Session.user.hpi_practitioner_number) {
						$scope.eOrdersStatus = {
							isMedlabDisabled: false,
							isPathlabDisabled: false,
							isAwanuiDisabled: false,
						};
					}
				// }
			},
			true
		);


		$scope.showConsultTimer = true; // TODO 

		$scope.$watch("SD.allergies", function (newValue, oldValue) {
			if (newValue && newValue.patientId === $scope.CP.patient.id) {
				if (!newValue.reload) {
					$scope.allergyList = newValue.allergyList.filter(t => t.status === 'ACTIVE');
					const count = $scope.allergyList.length;
					if (count === 0) {
						return $scope.allergyText = 'NKDA';
					}
					$scope.allergyText = count + (count > 1 ? ' Allergies' : ' Allergy');
				} else {
					$scope.SD.clearAllergiesReload($scope.CP.patient.id);
					fetchPatientAllergy();
				}
			}
		}, true);

		// The patient can confirm their contact details at any moment, from their own phone, while this
		// record sits open on someone's screen. The header is where the record lives for as long as it
		// is open, so this is where the verify dates are kept current.
		PatientVerificationLiveUpdateService.subscribe($scope, {
			patient: function () {
				return $scope.CP.patient;
			},
			onChanged: function () {
				// The dates are bound straight from CurrentPatient, so the patch is the render. The
				// saved snapshot is moved with them, so the change does not read as an unsaved edit.
				if ($scope.CP.patientBackup && $scope.CP.patientBackup.id === $scope.CP.patient.id) {
					$scope.CP.patientBackup.email_verify_date = $scope.CP.patient.email_verify_date;
					$scope.CP.patientBackup.mobile_number_verify_date = $scope.CP.patient.mobile_number_verify_date;
				}
			},
		});

		// Allergies live in this header - the count beside the name and the list behind it - on every
		// page of the record, so this is where another user's allergy change has to land. The fetch is
		// the header's own, which also re-publishes the list through ShareData for anything else bound
		// to it.
		PatientRecordLiveUpdateService.subscribeAllergies($scope, {
			patientId: function () {
				return $scope.CP.patient && $scope.CP.patient.id;
			},
			reload: function () {
				fetchPatientAllergy();
			},
		});

		this.$onInit = function () {
			$scope.xeroEnabled = Session.practice
				&& Session.practice.practiceFeatures
				&& Session.practice.practiceFeatures.billingFeature === true;

			if ($location.path().indexOf("operationNote") > -1) {
				$scope.headerText = "OPERATION NOTE";
			} else if ($location.path().indexOf("patientDashboard") > -1) {
				$scope.headerText = "PATIENT DASHBOARD";
			} else if ($location.path().indexOf("clinicalNote") > -1) {
				$scope.headerText = "VIRTUAL CONSULT";
			} else if ($location.path().indexOf("injectionNote") > -1) {
				$scope.headerText = "INJECTION NOTE";
			} else if ($location.path().indexOf("pre-op") > -1) {
				$scope.headerText = "WORKUP FOR SURGERY";
			} else if ($location.path().indexOf("surgeryAgreement") > -1) {
				$scope.headerText = "SURGERY AGREEMENT";
			} else if ($location.path().indexOf("medicalCertificate") > -1 && $stateParams.isReturnToWork) {
				$scope.headerText = "RETURN TO WORK CERTIFICATE";
			} else if ($location.path().indexOf("medicalCertificate") > -1) {
				$scope.headerText = "MEDICAL CERTIFICATE";
			} else if ($location.path().indexOf("clinic-letter") > -1) {
				$scope.headerText = "CLINIC LETTER";
			}else if($location.path().indexOf("/dicom-viewer") > -1){
				$scope.headerText = "DICOM VIEWER";
			}
			fetchPatientAllergy();

			fetchAppointmentsForPatient();

			$scope.patientContactList = [];
			$scope.contact_terms = { value: '' };
		};

		$scope.popoverComing = {
			content: "Coming Soon",
		};


		$scope.trigger = function () {
			$scope.$ctrl.onEditClick();
		};

		$scope.backDashboard = function(){
			if ($scope.headerText === 'PATIENT DASHBOARD') {
				// Ask the recorder to refresh its polling for uncompleted transcriptions. It used to be
				// destroyed and re-created for this, which stopped a recording in progress and marked
				// the appointment finished.
				if ($scope.transcriptionEnabled) {
					$scope.$broadcast('transcription-recorder-refresh');
				}
				return $scope.$ctrl.reload();
			}
			$window.history.back();
		};

		// Called from the template on every digest, so it has to hold up before the feature list is there.
		$scope.isFavouritePatient = function () {
			var favourites = Session.user.features && Session.user.features.favoritePatientsFeature;
			return !!favourites && favourites.some(t => t.patientId === $scope.CP.patient.id);
		};

		// "(75, F)" after the name and date of birth: age in whole years, then the gender's initial. The
		// age comes from the date's own digits, since new Date("YYYY-MM-DD") reads it as UTC midnight.
		// Either half is left out when it isn't recorded (gender is optional in AU).
		$scope.ageAndGender = function () {
			const patient = $scope.CP.patient || {};
			const parts = [];
			const dob = /^(\d{4})\D(\d{1,2})\D(\d{1,2})/.exec(patient.dateOfBirth || "");
			if (dob) {
				const today = new Date();
				const month = Number(dob[2]), day = Number(dob[3]);
				let age = today.getFullYear() - Number(dob[1]);
				if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) {
					age--;
				}
				parts.push(age);
			}
			const gender = { MALE: "M", FEMALE: "F", OTHER: "O" }[patient.gender];
			if (gender) {
				parts.push(gender);
			}
			return parts.length ? "(" + parts.join(", ") + ")" : "";
		};

		$scope.addOrRemovePatient = function (isAdd) {
			if (isAdd) {
				$scope.PA.addToFavourite($scope.CP.patient.id)
					.then(
						function (resp) {
							if ($scope.PA.isFavouriteResponseSuccess(resp.status)) {
								const added = {
									patientId: $scope.CP.patient.id,
									patientName: $scope.CP.patient.firstName + ' ' + $scope.CP.patient.lastName
								};
								Session.user.features.favoritePatientsFeature.push(added);
								$rootScope.$broadcast('favoritePatientsChanged');
							}
						},
						function (err) {
							console.error(err && err.status);
						}
					)
					.then(function () {
						$scope.PA.isProcessing = false;
					});
			} else {
				$scope.PA.removeFavourite($scope.CP.patient.id)
					.then(
						function (resp) {
							if ($scope.PA.isFavouriteResponseSuccess(resp.status)) {
								Session.user.features.favoritePatientsFeature =
									Session.user.features.favoritePatientsFeature.filter(t => t.patientId !== $scope.CP.patient.id);
								$rootScope.$broadcast('favoritePatientsChanged');
							}
						},
						function (err) {
							console.error(err && err.status);
						}
					)
					.then(function () {
						$scope.PA.isProcessing = false;
					});
			}
		};

		/**
		 * A patient address is a required field in NZ (optional in AU, mirroring
		 * the register/edit form's ng-required="countryCode!=='AU'"). Treat the
		 * address as missing when there is no address entry or line1 is empty.
		 */
		$scope.isPatientAddressMissing = function () {
			const addresses = $scope.CP.patient && $scope.CP.patient.addresses;
			if (!addresses || !addresses.length) {
				return true;
			}
			return !addresses[0].line1;
		};

		$scope.onGeneralClick = function () {
			if ($scope.generalModal) {
				$scope.generalModal.hide();
			}
		};

		$scope.startReferral = function () {
			// Block starting a referral until a patient address has been recorded
			// (required everywhere except AU). Checked here, at the entry point, so
			// the user isn't sent through the whole flow only to fail at the end.
			if ($scope.countryConfig.countryCode !== 'AU' && $scope.isPatientAddressMissing()) {
				$scope.generalModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.general.tpl.html",
					show: true,
					title: "Patient address required",
					content: "This patient does not have an address recorded. A patient address is required before referring the patient. Please update the patient's address and try again.",
					backdrop: true,
					keyboard: false,
				});
				return;
			}
			const isV2 = true;
			if (isV2) {
				$state.go("referral");
				return;
			}
			$scope.PA.isProcessing = true;
			$scope.RA.startReferral().then(
				function (resp) {
					$scope.CR.setReferral(resp.data);
					$scope.PA.isProcessing = false;
					$state.go("examination");
				},
				function (err) {
					console.error(err && err.status);
					$scope.PA.isProcessing = false;
				}
			);
		};

		$scope.allergyText = '';
		$scope.allergyList = [];

		function fetchPatientAllergy() {
			if ($scope.CP.patient && $scope.CP.patient.id && Session.hasPermission("PATIENT_ALLERGY_VIEW")) {
				const requestedPatientId = $scope.CP.patient.id;
				$scope.AllergyAPI.getNKDA(requestedPatientId).then(
					function (resp) {
						if (!$scope.CP.patient || $scope.CP.patient.id !== requestedPatientId) return;
						if (resp.data.no_known_drug_allergies) {
							// Said as such, rather than leaving whatever the header last showed.
							$scope.allergyList = [];
							$scope.allergyText = "NKDA";
							$scope.SD.setAllergies(requestedPatientId, []);
						} else {
							$scope.AllergyAPI.getAllergy(requestedPatientId).then(
								function (resp) {
									if (!$scope.CP.patient || $scope.CP.patient.id !== requestedPatientId) return;
									if (resp.data && resp.data.length > 0) {
										$scope.allergyList = resp.data.filter((t) => t.status === "ACTIVE");
										const count = $scope.allergyList.length;
										if (count === 0) {
											return ($scope.allergyText = "NKDA");
										}
										$scope.allergyText = count + (count > 1 ? " Allergies" : " Allergy");
									} else {
										$scope.allergyText = "NKDA";
									}
									$scope.SD.setAllergies(requestedPatientId, resp.data);
								},
								function (err) {
									console.error("Failed to load allergies:", err && err.status);
								}
							);
						}
					},
					function (err) { }
				);
			}
		}

		function searchInAdvance() {
			$scope.BillingAPI.isProcessing = true;
			$scope.isRegisterDisabled = false;
			const dob = $filter("date")(new Date($scope.CP.patient.dateOfBirth), 'dd/MM/yyyy');
			const nhi = $scope.CP.patient.nhi ? `, NHI: ${$scope.CP.patient.nhi}` : '';
			const term = `${$scope.CP.patient.firstName} ${$scope.CP.patient.lastName} (DOB: ${dob}${nhi})`;
			$scope.BillingAPI.getContact($scope.CP.patient.id, term).then(function (resp) {
				if (resp.data.length > 0) {
					$scope.isRegisterDisabled = true;
					setPatientContactList(resp.data);
				}
			}, function (error) {
				console.error(error && error.status);
			}).then(function () {
				$scope.BillingAPI.isProcessing = false;
			});
		}

		$scope.promptConnect = function () {
			$scope.connectPatient();
		};

		$scope.connectPatient = function () {
			var headerTitle = document.querySelector("#headerTitle");
			if (headerTitle) headerTitle.click();

			fetchContact($scope.CP.patient.id, '', true);
		};

		$scope.unlinkContact = function () {
			if (!$scope.linkedContact) {
				return;
			}
			$scope.BillingAPI.isProcessing = true;
			$scope.BillingAPI.unlinkContact($scope.CP.patient.id, $scope.linkedContact.contact_id).then(function (resp) {
				if ($scope.contactsModal) {
					$scope.contactsModal.hide();
				}
				$scope.hasLinkedContact = null;
				$scope.linkedContact = null;
			}, function (error) {
				console.error(error && error.status);
				showErrorDialog();
			}).then(function () {
				$scope.BillingAPI.isProcessing = false;
			});
		};

		function displayContactsModal() {
			$scope.contact_terms.value = '';
			const title = $scope.patientContactList.length > 0 ? 'Your patient in Xero' : 'Select your patient in Xero';
			$scope.contactsModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.billing-contacts-list.tpl.html",
				show: true,
				backdrop: "static",
				title,
				keyboard: false,
			});
		}

		$scope.selectedOrg = { value: null };
		$scope.resolveConflicts = function (orgList) {
			$scope.orgList = orgList;
			$scope.selectedOrg.value = null;
			$scope.orgListModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.billing-resolve-org-conflict.tpl.html",
				title: "Resolve organisation conflict",
				show: true,
				backdrop: "static",
				keyboard: false,
			});
		};

		$scope.saveOrg = function () {
			if (!$scope.selectedOrg.value) {
				return;
			}

			$scope.BillingAPI.isProcessing = true;
			$scope.BillingAPI.setXeroOrg($scope.selectedOrg.value)
				.then(
					function (resp) {
						if ($scope.orgListModal) {
							$scope.orgListModal.hide();
						}
					},
					function (error) {
						showErrorDialog();
						console.error(error && error.status);
					}
				)
				.then(function () {
					$scope.BillingAPI.isProcessing = false;
				});
		};

		$scope.triggerSearch = function () {
			if ($scope.contact_terms.value) {
				fetchContact($scope.CP.patient.id, $scope.contact_terms.value, false);
			}
		};

		$scope.linkedContact = null;
		function fetchContact(patientId, term, showModal) {
			$scope.BillingAPI.isProcessing = true;
			$scope.linkedContact = null;
			$scope.BillingAPI.getContact(patientId, term).then(function (resp) {
				setPatientContactList(resp.data);
				if (!term && $scope.patientContactList.length > 0) {
					$scope.linkedContact = $scope.patientContactList[0];
				}
				if (showModal) {
					displayContactsModal();
					if (!$scope.linkedContact) {
						searchInAdvance();
						return;
					}
				}
				$scope.BillingAPI.isProcessing = false;
			}, function (error) {
				console.error(error && error.status);
				$scope.BillingAPI.isProcessing = false;
				showErrorDialog();
			});
		}

		$scope.registerPatient = function () {
			$scope.BillingAPI.isProcessing = true;
			$scope.BillingAPI.registerContact($scope.CP.patient.id).then(function (resp) {
				if ($scope.contactsModal) {
					$scope.contactsModal.hide();
				}

				return checkLinkedStatus().then(function () {
					$timeout(function () {
						$scope.openBillingModal('LIST');
					}, 100);
				});

			}).catch(function (error) {
				console.error(error && error.status);
				showErrorDialog();
			}).finally(function () {
				$scope.BillingAPI.isProcessing = false;
			});
		};

		$scope.linkPatient = function () {
			$scope.BillingAPI.isProcessing = true;
			$scope.BillingAPI.linkContract($scope.CP.patient.id, $scope.selectedContract.contact_id).then(function (resp) {
				if ($scope.contactsModal) {
					$scope.contactsModal.hide();
				}

				return checkLinkedStatus().then(function () {
					$timeout(function () {
						$scope.openBillingModal('LIST');
					}, 100);
				});

			}).catch(function (error) {
				console.error(error && error.status);
				showErrorDialog();
			}).finally(function () {
				$scope.BillingAPI.isProcessing = false;
			});
		};

		$scope.checkboxModel = {};
		$scope.selectedContract = null;

		// Called from the row itself, not just the checkbox, so the whole row is clickable.
		$scope.selectContact = function (index) {
			const state = !$scope.checkboxModel[`${index}`];
			$scope.patientContactList.forEach((element, i) => {
				$scope.checkboxModel[`${i}`] = false;
			});
			$scope.checkboxModel[`${index}`] = state;
			if (state) {
				$scope.selectedContract = $scope.patientContactList[index];
			} else {
				$scope.selectedContract = null;
			}
		};

		function setPatientContactList(list) {
			$scope.patientContactList = list;
			$scope.checkboxModel = {};
			$scope.selectedContract = null;
			// Only one contact to choose from - there is nothing to decide, so preselect it.
			if (list.length === 1) {
				$scope.checkboxModel["0"] = true;
				$scope.selectedContract = list[0];
			}
		}

		function showErrorDialog() {
			$scope.serverErrorModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
				show: true,
				title: "CatTrax has encountered an error",
			});
		}

		$scope.isPractitionerAvailable = function () {
			if (!$scope.CP.patient.practitioners || $scope.CP.patient.practitioners.length === 0) {
				return false;
			}
			return true;
		};

		$scope.formatPractitioner = function () {
			if ($scope.CP.patient.practitioners && $scope.CP.patient.practitioners.length > 0) {
				let practitioner = $scope.CP.patient.practitioners[0].practitioner;
				if (!practitioner) {
					practitioner = "unknown";
				} else {
					practitioner = `${practitioner.name}`;
				}
				return practitioner;
			}
			return "unknown";
		};

		// --- XERO & INVOICE INITIALIZATION LOGIC ---

		$scope.isLoggedIn = false;
		$scope.hasLinkedContact = null;
		$scope.accounts = [];
		$scope.taxRates = [];
		$scope.providerId = "";

		$scope.checkPatientXeroConnection = function () {
			if ($scope.isLoggedIn) {
				checkLinkedStatus();
			} else {
				getLoggedIn();
			}
		};

		function getLoggedIn() {
			$scope.BillingAPI.isProcessing = true;
			$scope.BillingAPI.getLoggedIn()
				.then(function (resp) {
					if (resp.data.error_organisation_conflict) {
						getXeroOrg();
					} else if (resp.data.logged_in_to) {
						$scope.isLoggedIn = true;
						Session.setXeroLoginState(true);
						// Populate scope directly instead of emitting to parent
						$scope.accounts = angular.copy(resp.data.accounts);
						$scope.taxRates = angular.copy(resp.data.tax_rates);
						$scope.providerId = angular.copy(resp.data.tyro_provider_id);
						checkLinkedStatus();
					} else {
						Session.setXeroLoginState(false);
						popUpLogin();
					}
				})
				.catch(function () {
					// The Xero login state is deliberately left as it was. Xero's API times out often
					// enough that /api/billing/auth fails while the practice is still perfectly well
					// connected, and a request that never landed is not an answer: writing false here
					// signed the user out of Xero for the rest of the session - the profile menu flipped
					// to "Login Xero" and InvoiceLiveUpdateService stopped fetching invoices, neither of
					// which recovers when Xero does. The next attempt asks again.
					// Nothing is logged - the response carries billing data.
					showErrorDialog();
				})
				.finally(function () {
					$scope.BillingAPI.isProcessing = false;
				});
		}

		function checkLinkedStatus() {
			$scope.BillingAPI.isProcessing = true;
			return $scope.BillingAPI.getContact($scope.CP.patient.id, "")
				.then(function (resp) {
					if (resp.data && resp.data.length > 0) {
						$scope.hasLinkedContact = resp.data[0];
						$scope.linkedContact = resp.data[0];
					} else {
						$scope.hasLinkedContact = null;
						$scope.linkedContact = null;
					}
				})
				.catch(function (error) {
					console.error(error && error.status);
					showErrorDialog();
					$scope.hasLinkedContact = null;
					$scope.linkedContact = null;
				})
				.finally(function () {
					$scope.BillingAPI.isProcessing = false;
				});
		}

		function getXeroOrg() {
			$scope.BillingAPI.isProcessing = true;
			$scope.BillingAPI.getXeroOrg()
				.then(function (resp) {
					$scope.resolveConflicts(angular.copy(resp.data));
				})
				.catch(function (error) {
					console.error(error && error.status);
					showErrorDialog();
				})
				.finally(function () {
					$scope.BillingAPI.isProcessing = false;
				});
		}

		function popUpLogin() {
			$scope.loginInvoiceModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.invoice-login.tpl.html",
				show: true,
				backdrop: "static",
				keyboard: false,
			});
		}

		$scope.loginXero = function () {
			if ($scope.loginInvoiceModal) {
				$scope.loginInvoiceModal.hide();
			}
			$scope.BillingAPI.isProcessing = true;
			$scope.BillingAPI.getXeroLoginUrl()
				.then(function (resp) {
					const xeroUrl = resp.data;
					$window.open(xeroUrl, "_blank", "location=no,toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=500,width=500,height=600");
				})
				.catch(function (error) {
					console.error(error && error.status);
					showErrorDialog();
				})
				.finally(function () {
					$scope.BillingAPI.isProcessing = false;
				});
		};

		// A lens job's tile asks for the job's invoice: opened here, where the accounts and the patient's Xero
		// contact are, the way Patient invoicing opens. The tile reads its jobs again once it closes.
		$scope.$on("billing:openInvoice", function (e, invoiceId, onClosed) {
			if (!$scope.xeroEnabled || $scope.CP.isPatientNew) return;
			e.preventDefault();
			const shown = $scope.openBillingModal("LIST", invoiceId);
			if (shown && onClosed) shown.finally(onClosed).catch(angular.noop);
		});

		// `invoiceId` opens the dialog on that invoice (NZ) rather than the newest.
		$scope.openBillingModal = function (action, invoiceId) {
			const contact = $scope.hasLinkedContact || $scope.linkedContact;

			// Xero contact is still required for invoicing/claiming creation
			if (action === 'CREATE' && !contact) return;

			var headerTitle = document.querySelector("#headerTitle");
			if (headerTitle) headerTitle.click();

			if ($scope.countryConfig && $scope.countryConfig.medicareFeatureEnabled) {
				// --- AUSTRALIAN CLAIMING FLOW ---
				return $mdDialog.show({
					controller: "claimModalController",
					templateUrl: "app/src/js/components/invoice/claim-modal.tmpl.html",
					parent: angular.element(document.body),
					clickOutsideToClose: false,
					scope: $scope.$new(true),
					preserveScope: false,
					resolve: {
						accounts: function () { return $scope.accounts; },
						// The organisation's own tax rates. A claim is GST-free whatever they say, but a direct
						// patient invoice can carry GST, and the rate it is worked out at is the practice's.
						taxRates: function () { return $scope.taxRates; },
						providerId: function () { return $scope.providerId; },
						initialAction: function () { return action; }
					},
				}).catch(function (error) {
					console.error("FATAL MODAL ERROR:", error);
				});
			} else {
				// --- NEW ZEALAND INVOICING FLOW ---
				return $mdDialog.show({
					controller: "invoiceModalController",
					templateUrl: "app/src/js/components/invoice/invoice-modal.tmpl.html",
					parent: angular.element(document.body),
					clickOutsideToClose: false,
					scope: $scope.$new(true),
					preserveScope: false,
					resolve: {
						accounts: function () { return $scope.accounts; },
						taxRates: function () { return $scope.taxRates; },
						providerId: function () { return $scope.providerId; },
						initialAction: function () { return action; },
						initialInvoiceId: function () { return invoiceId || null; },
						billingContactId: function () { return contact ? contact.contact_id : null; }
					},
				});
			}
		};

		$scope.openCalendar = function () {
			$mdDialog.show({
				controller: "calendarController",
				templateUrl: "app/src/views/templates/calendar.tmpl.html",
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				fullscreen: $scope.customFullscreen,
				openFrom: "#anchor",
				closeTo: "#anchor",
				scope: $scope.$new(true),
				preserveScope: false,
				resolve: {
					patientId: () => $scope.CP.patient.id,
					patientName: () => $scope.CP.patient.firstName + " " + $scope.CP.patient.lastName,
					selectedAppointment: () => $scope.selectedAppointment,
				},
				onRemoving: () => {
					$scope.tooltipHide = false;
					fetchAppointmentsForPatient();
					$scope.selectedAppointment = null;
				},
			});
		};

		$scope.appointments = [];
		$scope.tooltipHide = false;
		$scope.appointmentsPopover = { open: false };

		// The list under "Book appointment" was fetched once, when the header loaded, so a booking moved since -
		// by someone else, or from the calendar opened anywhere but here - was still shown at its old time.
		// It is fetched again each time the popover opens, and whenever one of this patient's appointments
		// changes at the practice.
		let appointmentsPatientId = null;
		let appointmentsRequest = 0;

		function fetchAppointmentsForPatient() {
			if (!$scope.CP.patient || !$scope.CP.patient.id
				|| !$scope.CALENDAR_ENABLE || !Session.hasPermission("SCHEDULE_APPOINTMENT_VIEW")) {
				return;
			}
			const patientId = $scope.CP.patient.id;
			// A refresh for the same patient keeps the list on screen until the new one lands, rather than
			// flashing "No Appointments" in an open popover.
			if (appointmentsPatientId !== patientId) {
				appointmentsPatientId = patientId;
				$scope.appointments = [];
			}
			$scope.isDataReady = false;
			const request = ++appointmentsRequest;
			$scope.AppointmentAPI.getAppointmentsForPatient(patientId).then(
				function (response) {
					// Only the latest request counts - an earlier one landing late would put the old times back.
					if (request !== appointmentsRequest || patientId !== ($scope.CP.patient && $scope.CP.patient.id)) {
						return;
					}
					$scope.appointments = response.data;
					$scope.isDataReady = true;
				},
				function (error) { }
			);
		}

		$scope.openAppointmentsPopover = function () {
			$scope.appointmentsPopover.open = true;
			fetchAppointmentsForPatient();
		};

		function onAppointmentPushEvent(e, pushEvent) {
			const data = (pushEvent && pushEvent.data) || {};
			if (data.patientId && $scope.CP.patient && String(data.patientId) === String($scope.CP.patient.id)) {
				fetchAppointmentsForPatient();
			}
		}
		$scope.$on(PUSH_EVENTS.APPOINTMENT_ADDED, onAppointmentPushEvent);
		$scope.$on(PUSH_EVENTS.APPOINTMENT_UPDATED, onAppointmentPushEvent);
		$scope.$on(PUSH_EVENTS.APPOINTMENT_DELETED, onAppointmentPushEvent);

		$scope.acceptAllergy = function (row) {
			$scope.AllergyAPI.isProcessing = true;

			var allergyObj = angular.copy(row);
			allergyObj.is_human_verified = "VERIFIED";

			$scope.AllergyAPI.updateAllergy($scope.CP.patient.id, row.patient_allergy_id, allergyObj)
				.then(function () {
					$scope.AllergyAPI.isProcessing = false;
					fetchPatientAllergy();
				},
					function (err) {
						$scope.AllergyAPI.isProcessing = false;
						console.error("Failed to update allergy:", err && err.status);
					});
		};

		$scope.rejectAllergy = function (row) {
			$scope.AllergyAPI.isProcessing = true;

			var allergyObj = angular.copy(row);
			allergyObj.is_human_verified = "REJECTED";

			$scope.AllergyAPI.updateAllergy($scope.CP.patient.id, row.patient_allergy_id, allergyObj)
				.then(function () {
					$scope.AllergyAPI.isProcessing = false;
					fetchPatientAllergy();
				},
					function (err) {
						$scope.AllergyAPI.isProcessing = false;
						console.error("Failed to update allergy:", err && err.status);
					});
		};

		$scope.triggerCalendarModal = function (appointment) {
			$scope.tooltipHide = true;
			$scope.selectedAppointment = appointment;
			$scope.openCalendar();
		};

		$scope.showDymoPrinter = function (ev) {
			$mdDialog.show({
				controller: "dymoDiagnosisController",
				templateUrl: "app/src/js/components/dymoDiagnosis/dymoDiagnosis.html",
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				fullscreen: $scope.customFullscreen,
				openFrom: "#anchor",
				closeTo: "#anchor",
				scope: $scope.$new(true),
				preserveScope: false,
				resolve: {},
			});
		};

		$scope.showCareTeam = function (event) {
			console.log("onShowCareTeam");
		};

		$scope.showClinicLetter = function (ev) {
			$state.go("clinic-letter");
		};

		$scope.showPatientForms = function () {
			PatientFormsAPI.isProcessing = true;

			PatientFormsAPI.getCustomForms()
				.then(function (resp) {
					PatientFormsAPI.isProcessing = false;
					SettingsDialog.openPatientForms({
						templates: resp.data,
						patientId: $scope.CP.patient ? $scope.CP.patient.id : null,
						patientName: $scope.CP.patient ? $scope.CP.patient.firstName + ' ' + $scope.CP.patient.lastName : '',
						patientEmail: $scope.CP.patient ? $scope.CP.patient.email : '',
					}).catch(function () {
						// Dismissed - $mdDialog rejects on cancel and there is nothing to do with it.
					});
				})
				.catch(function () {
					showErrorDialog();
				})
				.finally(function () {
					PatientFormsAPI.isProcessing = false;
				});
		};

	},
]);